var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawn-number",class:{'retail' : _vm.isRetail},style:(_vm.getStyle)},[(!_vm.inProgress)?_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),_c('DrawnNumberSpinner',{attrs:{"spinner-color":"#fff","bg-color":"#000","show":_vm.inProgress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }